import { render, staticRenderFns } from "./editframework.vue?vue&type=template&id=1cf7840d&scoped=true&"
import script from "./editframework.vue?vue&type=script&lang=js&"
export * from "./editframework.vue?vue&type=script&lang=js&"
import style0 from "./editframework.vue?vue&type=style&index=0&id=1cf7840d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf7840d",
  null
  
)

export default component.exports